import React from "react";
import ReusableEdit from "../../Subscription/ReusableEdit";

function Edit() {
  return <ReusableEdit title={"Trial"}></ReusableEdit>;
}

export default Edit;
